import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["inert"]

import { provide, ref, type Component } from "vue";
import { studioEditorActiveKey } from "./studioSessionHistory";
import type { StudioEditorKind } from "./studioSidebar";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioEditorSession',
  props: {
    active: { type: Boolean },
    editor: {},
    kind: {}
  },
  emits: ["update:editorKind"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const editorRef = ref<{ prepareToLeave: () => Promise<void> }>();
provide(studioEditorActiveKey, () => props.active);
__expose({ prepareToLeave: () => editorRef.value?.prepareToLeave() ?? Promise.resolve() });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "studio-editor-session",
    inert: !__props.active
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.editor), {
      ref_key: "editorRef",
      ref: editorRef,
      "editor-kind": __props.kind,
      "onUpdate:editorKind": _cache[0] || (_cache[0] = ($event: any) => (emit('update:editorKind', $event)))
    }, null, 40, ["editor-kind"]))
  ], 8, _hoisted_1)), [
    [_vShow, __props.active]
  ])
}
}

})